import React from 'react';
import { Flex, Typography } from 'antd';

const { Text, Paragraph } = Typography;

/** Line item name + optional description in table cells */
const DocumentLineDescription = ({ name, description }) => (
  <Flex vertical gap={0}>
    <Text strong style={{ fontSize: 13 }}>{name ?? '—'}</Text>
    {description ? (
      <Paragraph type="secondary" style={{ margin: 0, fontSize: 12 }}>{description}</Paragraph>
    ) : null}
  </Flex>
);

export default DocumentLineDescription;
